import React from "react";
import { Box, Grid, Paper, Typography, AppBar, Toolbar, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PeopleIcon from "@mui/icons-material/People";
import SchoolIcon from "@mui/icons-material/School";
import GroupIcon from "@mui/icons-material/Group";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AdminHeader from "../AdminHeader/AdminHeader";

const StatCard = ({ title, value, icon }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        borderRadius: 3,
        display: "flex",
        alignItems: "center",
        gap: 2,
        bgcolor: "#ffffff",
        marginTop: "80px",
      }}
    >
      <Box
        sx={{
          width: 50,
          height: 50,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#e8f0fe",
        }}
      >
        {icon}
      </Box>

      <Box>
        <Typography variant="subtitle2" sx={{ color: "gray" }}>
          {title}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {value}
        </Typography>
      </Box>
    </Paper>
  );
};

const AdminDashboard = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* HEADER BAR */}

        <AdminHeader/>
      {/* PAGE CONTENT */}
      <Box sx={{ p: 4, bgcolor: "#f3f4f6", minHeight: "100vh" }}>
        
        <Grid container spacing={3}>
          
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Total Users"
              value="1245"
              icon={<PeopleIcon sx={{ color: "#1a73e8" }} />}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Active Teachers"
              value="64"
              icon={<SchoolIcon sx={{ color: "#10b981" }} />}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Active Students"
              value="1180"
              icon={<GroupIcon sx={{ color: "#f59e0b" }} />}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="App Version"
              value="1.0.0"
              icon={<AppSettingsAltIcon sx={{ color: "#6366f1" }} />}
            />
          </Grid>

        </Grid>
      </Box>
    </>
  );
};

export default AdminDashboard;

